/** GA4 event-parameter policy that cannot mutate session acquisition. */

const ACQUISITION_PARAM_RENAMES: Readonly<Record<string, string>> = {
  source: "interaction_source",
  medium: "interaction_medium",
  campaign: "interaction_campaign",
  campaign_id: "interaction_campaign_id",
  term: "interaction_term",
  content: "interaction_content",
};

const CLICK_ID_PARAMS = new Set(["gclid", "dclid", "gbraid", "wbraid"]);

/** Return a GA-safe event key, preserving business context under a namespace. */
export function ga4EventParamName(key: string): string | null {
  const lower = key.toLowerCase();
  if (CLICK_ID_PARAMS.has(lower)) return null;
  return ACQUISITION_PARAM_RENAMES[lower] ?? key;
}

/** Rename or remove acquisition-reserved fields before any GA/GTM fanout. */
export function ga4SafeEventProperties(
  properties: Readonly<Record<string, unknown>>
): Record<string, unknown> {
  const safe: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(properties)) {
    const target = ga4EventParamName(key);
    if (target) safe[target] = value;
  }
  return safe;
}
